// extracted by mini-css-extract-plugin
export default {"root":"Date__root--3nJRh","expires":"Date__expires--18lIo"};